// extracted by mini-css-extract-plugin
export default {"card":"App_card__Uzngl","smallMenu":"App_smallMenu__ItrgQ","modal":"App_modal__1-yrb"};